module.exports = __webpack_public_path__ + "media/images/user-ea248491dbaeb0b56fd993a06f4092b0.svg";